import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { ApplicationState } from '../../../lib/Store';
import { DashboardPanelWrapper, Header, HeaderContainer, HeaderImage, SubHeader, SubText, TitleWrapper } from '../DashboardTeamConnectionPoints/Styles';
import { socialsGraphic } from 'src/assets/icons';
import BarGraph from '../DashboardTeamConnectionPoints/BarGraph';

interface SurveyRewardsSummaryProps {
  className?: string;
}

const SurveyRewardsSummary: FC<SurveyRewardsSummaryProps> = ({ className }) => {
  const { teamMembersPoints } = useSelector(
    (state: ApplicationState) => state.participantDashboardState
  );


  return (
    <DashboardPanelWrapper>
      <HeaderContainer>
        <TitleWrapper>
          <Header>Survey Points</Header>
          <SubHeader>Your Team</SubHeader>
          <SubText>Track your survey completion progress</SubText>
        </TitleWrapper>
        <HeaderImage src={socialsGraphic} />
      </HeaderContainer>
      <BarGraph data={teamMembersPoints} pointType="SURVEY" />
    </DashboardPanelWrapper>
  );
};

export default SurveyRewardsSummary; 